import { CoveredRegion, District, PropositionAllocation } from "@hubcapp/types";
import { getDefaultFranchiseProductCategory } from "@hubcapp/utils";

export const getAreaDefaultPrice = (
  coverage: CoveredRegion,
  franchise: PropositionAllocation,
) => {
  const defaultProductCategory = getDefaultFranchiseProductCategory(franchise);

  const instructorPricing = coverage.pricing?.find(
    price => price?.productCategory?.type === defaultProductCategory,
  );

  if (instructorPricing) {
    return instructorPricing.price;
  }

  // get region default price if instructor pricing is undefined
  return coverage.region.pricing?.find(
    price => price?.productCategory?.type === defaultProductCategory,
  )?.recommendedPrice;
};

export const getCoverageCount = (districts: Partial<District | null>[]) =>
  `${districts.filter(district => district?.covered).length} of ${
    districts.length
  }`;
